function asArrayBufferView(T, a) {
    if (a instanceof T) {
        return a;
    }
    if ("buffer" in a) {
        return new T(a.buffer, a.byteOffset, a.byteLength);
    }
    return new T(a);
}
/** Convert (Shared)ArrayBuffer(View) to Uint8Array. */
export function asUint8Array(a) {
    return asArrayBufferView(Uint8Array, a);
}
/** Convert (Shared)ArrayBuffer(View) to DataView. */
export function asDataView(a) {
    return asArrayBufferView(DataView, a);
}
